module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade custom-modal auth-modal",
    attrs: {
      "id": "reset-modal",
      "role": "dialog",
      "aria-labelledby": "reset-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendRequest($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.email),
      expression: "rules.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "user@ezifood.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-fill small-margin-top btn-block",
    attrs: {
      "type": "submit",
      "disabled": !_vm.email
    }
  }, [_vm._v("Send Request")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "auth-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logowithname.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Request Password Reset")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-891a4876","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ResetModal.vue
// module id = 215
// module chunks = 14